/* Atelier Loreti - shared runtime for the L.1T sections.
   Loaded by every section as <script type="module">: the browser runs a module URL once, so this executes a single time.
   Provides: motion flags, the reveal observer, a shared scroll/resize frame loop, the stone bus (Charoite / obsidian
   choice shared between hero, tourbillon, object and form) and section (re)initialisation for the theme editor. */
const D = document, W = window, R = D.documentElement;
R.classList.add('js');
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
const $ = (s, r = D) => r.querySelector(s), $$ = (s, r = D) => [...r.querySelectorAll(s)];
const cl = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x));
const sst = (a, b, x) => { const t = cl((x - a) / (b - a)); return t * t * (3 - 2 * t); };

/* one scroll loop for every section */
const frameFns = new Set(); let raf = 0;
function frame() { raf = 0; const vh = innerHeight; frameFns.forEach(f => { try { f(vh); } catch (e) { console.error('[atelier]', e); } }); }
function request() { if (!raf) raf = requestAnimationFrame(frame); }
addEventListener('scroll', request, { passive: true }); addEventListener('resize', request);
function onFrame(fn) { frameFns.add(fn); request(); return () => frameFns.delete(fn); }

/* reveals: [data-rv] and [data-lines] enter when they come into view; a section marked data-own-reveal runs its own cue */
let io = null;
function reveal(root = D) {
  const els = $$('[data-rv],[data-lines]', root).filter(e => !e.closest('[data-own-reveal]'));
  if (reduce || !('IntersectionObserver' in W)) { els.forEach(e => e.dataset.in = ''); return; }
  io = io || new IntersectionObserver(en => en.forEach(x => { if (x.isIntersecting) { x.target.dataset.in = ''; io.unobserve(x.target); } }), { rootMargin: '0px 0px -6% 0px' });
  els.forEach(e => io.observe(e));
}

/* the edition name changes in place, rising into view. Names come from data-name-cha / data-name-obs on the element. */
const EDN = { cha: 'Charoite', obs: 'snowflake obsidian' };
function edName(el, k) {
  if (!el) return; const t = el.getAttribute('data-name-' + k) || EDN[k];
  if (!t || el.textContent === t) return;
  el.textContent = t; el.removeAttribute('data-swap'); void el.offsetWidth; if (!reduce) el.dataset.swap = '';
}

/* stone bus: 'cha', 'obs' or 'both' */
let stone = 'cha';
function pickStone(k, from) { if (k !== 'cha' && k !== 'obs' && k !== 'both') return; stone = k; D.dispatchEvent(new CustomEvent('atelier:stone', { detail: { stone: k, from } })); }
function onStone(fn) { const h = e => fn(e.detail.stone, e.detail.from); D.addEventListener('atelier:stone', h); return () => D.removeEventListener('atelier:stone', h); }

/* sections register an init; it runs now for every matching root and again whenever the theme editor re-renders one */
const inits = {};
function boot(el, fn) { if (el.dataset.atlReady) return; el.dataset.atlReady = '1'; try { el._atlDispose = fn(el) || null; } catch (e) { console.error('[atelier] ' + el.dataset.atelier, e); } }
function section(type, fn) { inits[type] = fn; $$(`[data-atelier="${type}"]`).forEach(el => boot(el, fn)); }
D.addEventListener('shopify:section:load', e => { $$('[data-atelier]', e.target).forEach(el => { const fn = inits[el.dataset.atelier]; if (fn) boot(el, fn); }); reveal(e.target); request(); });
D.addEventListener('shopify:section:unload', e => { $$('[data-atelier]', e.target).forEach(el => { if (typeof el._atlDispose === 'function') el._atlDispose(); }); });

/* the theme's own chrome above the page (announcement bar, header): its visible bottom edge and its full height,
   exposed as CSS variables so the Atelier header can sit under it and the hero can fit the first screen */
const CHROME_SEL = '.shopify-section-group-header-group:not(.atl), #shopify-section-header:not(.atl), #shopify-section-announcement-bar:not(.atl), [id^="shopify-section-"][id*="announcement"]:not(.atl), [id^="shopify-section-"][id*="header"]:not(.atl)';
let chromeH = -1;
function chrome() {
  let bottom = 0, full = 0;
  $$(CHROME_SEL).forEach(el => { const r = el.getBoundingClientRect(); if (r.height <= 0 || r.width <= 0) return; bottom = Math.max(bottom, r.bottom); full = Math.max(full, r.bottom + scrollY); });
  R.style.setProperty('--atl-chrome', Math.max(0, Math.round(bottom)) + 'px');
  if (scrollY <= 1 || chromeH < 0) { const h = Math.max(0, Math.round(full)); if (h !== chromeH) { chromeH = h; R.style.setProperty('--atl-chrome-h', h + 'px'); } }
}
frameFns.add(chrome); chrome();
addEventListener('load', () => { chromeH = -1; chrome(); });

/* marketing hooks: a button with data-klaviyo-form opens that Klaviyo form; data-fb-lead fires a Meta pixel "Lead" event
   (on click, or when the matching Klaviyo form is submitted). Both degrade silently when the scripts are not on the store. */
const pixels = new Set();
function canTrack() { const cp = W.Shopify && W.Shopify.customerPrivacy; return !(cp && typeof cp.userCanBeTracked === 'function' && !cp.userCanBeTracked()); }
function ensurePixel(id) { // the store may already run the Meta pixel (sales channel or custom pixel); otherwise load it for this ID
  if (!id || pixels.has(id)) return;
  if (typeof W.fbq !== 'function') {
    if (!canTrack()) return;
    (function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); })(W, D, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    W.fbq('init', id); W.fbq('track', 'PageView');
  } else { try { W.fbq('init', id); } catch (e) { /* already initialised */ } }
  pixels.add(id);
}
function fbLead(name, pixel) {
  if (pixel) ensurePixel(pixel);
  if (typeof W.fbq !== 'function') return;
  const data = { content_name: name || 'Atelier CTA' };
  try { if (pixel) W.fbq('trackSingle', pixel, 'Lead', data); else W.fbq('track', 'Lead', data); } catch (e) { /* pixel refused */ }
}
function openKlaviyo(id) { W._klOnsite = W._klOnsite || []; W._klOnsite.push(['openForm', id]); }
const pendingLeads = {}; // klaviyo form id -> {name, pixel}, armed by a click, fired on that form's submit
D.addEventListener('click', e => {
  const a = e.target.closest && e.target.closest('[data-klaviyo-form],[data-fb-lead]'); if (!a) return;
  const form = a.getAttribute('data-klaviyo-form'), lead = a.getAttribute('data-fb-lead'), on = a.getAttribute('data-fb-lead-on') || 'click', pixel = a.getAttribute('data-fb-pixel') || '';
  if (lead !== null) { if (on === 'submit' && form) pendingLeads[form] = { name: lead, pixel }; else fbLead(lead, pixel); }
  if (form) { e.preventDefault(); openKlaviyo(form); }
});
W.addEventListener('klaviyoForms', e => {
  const d = e && e.detail; if (!d || d.type !== 'submit') return;
  const id = String(d.formId || ''); const lead = pendingLeads[id];
  if (lead) { fbLead(lead.name, lead.pixel); delete pendingLeads[id]; }
});

reveal();
W.Atelier = { D, W, R, reduce, fine, $, $$, cl, sst, onFrame, request, reveal, edName, pickStone, onStone, section, fbLead, ensurePixel, openKlaviyo, get stone() { return stone; } };
export default W.Atelier;
